// A small curated set of reflection prompts shown in the capture drawer.
// M1 has NO AI generation (spec §10) — these are hand-written, not model output.
export const RECORDING_PROMPTS: string[] = [
  "What do you know now that you wish you'd known at twenty?",
  'Describe a moment you felt most proud of them.',
  'What do you hope they carry with them, always?',
  'Tell them about the day they came into your life.',
  'What does love mean to you, in your own words?',
];
